import { create } from 'zustand';

/**
 * Whether an X-ray opens on the automatic window (windowing openingWindow, read
 * by DmvEngine as it opens one) rather than the device's: off unless chosen in
 * Settings (user, 2026-10-16). Auto and Reset stay in the window box on every
 * image either way. Kept in this browser and on the account
 * (`viewerXrayAutoWindow`, features/viewer-controls/xrayAutoWindow).
 */
const KEY = 'tr.viewerXrayAutoWindow';

function stored(): boolean {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export const useViewerXrayAutoWindow = create<{ on: boolean; set: (on: boolean) => void }>((set, get) => ({
  on: stored(),
  set: (on) => {
    if (on === get().on) return;
    try {
      window.localStorage.setItem(KEY, on ? '1' : '0');
    } catch {
      /* private browsing: the choice lasts this page */
    }
    set({ on });
  },
}));
